export enum RecallType {
  ER = "ER",
  SC = "SC",
  SR = "SR",
  CS = "CS"
}
